import { render, staticRenderFns } from "./filterShrink.vue?vue&type=template&id=31a76ed3&scoped=true"
import script from "./filterShrink.vue?vue&type=script&lang=js"
export * from "./filterShrink.vue?vue&type=script&lang=js"
import style0 from "./filterShrink.vue?vue&type=style&index=0&id=31a76ed3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a76ed3",
  null
  
)

export default component.exports